import * as React from 'react';
import './time-input.scss';
import { ReactComponent as ClockIcon } from '../../assets/icons/icon_clock.svg';
import moment from 'moment';

interface Props {
  onChange: React.ChangeEventHandler<HTMLInputElement>;
  label?: string;
  inputName?: string;
  value?: string;
  placeholder?: string;
  disabled?: boolean;
  iconSide?: 'LEFT' | 'RIGHT';
}

const TimeInput: React.FunctionComponent<Props> = ({
  onChange,
  label,
  inputName,
  value,
  placeholder = '00:00',
  disabled = false,
  iconSide = 'LEFT',
}) => {
  const iconClick = () => {
    // logic for icon click
  };

  const ref = React.useRef<HTMLInputElement>(null);

  const pickClassName = () => {
    let className = '';
    if (iconSide) {
      className = 'time-input__input-left';
    } else {
      className = 'time-input__input-right';
    }

    if (!value) {
      className = `${className} + time-input__default`;
    }

    return className;
  };

  return (
    <div className="text-input">
      {label && label.length > 0 && <div className="time-input__label">{label}</div>}
      <div
        className={iconSide === 'LEFT' ? 'time-left' : 'time-right'}
        onClick={() => {
          if (ref.current) ref.current?.showPicker();
        }}>
        <ClockIcon className={'time-icon'} onClick={iconClick} />
      </div>
      <input
        ref={ref}
        type="time"
        id="timepicker"
        name={inputName}
        value={value || '00:00'}
        onChange={onChange}
        className={pickClassName()}
        disabled={disabled}
        placeholder={placeholder}
      />
    </div>
  );
};
export default TimeInput;
